<script setup lang="ts">
// NPM
import type { PropType } from 'vue';

// Components
import { BaseAvatar } from '@magma-app/magma-lapilli';

// Props
defineProps({
  errorCode: {
    type: Number as PropType<number | null>,
    default: 0,
  },
  isLogged: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});
</script>

<template>
  <div class="flex min-h-full flex-col bg-background-default pt-16 pb-12">
    <main
      class="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8"
    >
      <div class="flex flex-shrink-0 justify-center">
        <a class="inline-flex" href="/login">
          <BaseAvatar src="/img/logo_magma.png" size="lg" />
        </a>
      </div>

      <div class="py-10">
        <div class="text-center">
          <p class="text-base font-semibold text-foreground-brand-default">
            {{ $t('errorView.error') + (errorCode || '') }}
          </p>

          <h1
            class="mt-2 text-4xl font-bold tracking-tight text-foreground-emphasis sm:text-5xl"
          >
            {{
              errorCode && errorCode >= 400 && errorCode < 500
                ? $t('errorView.oops')
                : $t('errorView.notFound')
            }}
          </h1>

          <p class="mt-2 text-base text-foreground-subtle">
            {{
              errorCode === 400 ? $t('errorView.wrong') : $t('errorView.sorry')
            }}
          </p>

          <div class="mt-6">
            <a
              class="text-base font-medium text-foreground-brand-default hover:text-border-default"
              href="/login"
            >
              {{ $t('generic.backToLogin')
              }}<span aria-hidden="true"> &rarr;</span>
            </a>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
